import { FC, PropsWithChildren, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import useHasPermission from '@/hooks/useHasPermission';
import { Permission } from '@/types/resources';

import Button from '../Button';
import Text from '../Text';

const Wrap = styled.div`
  background: ${({ theme }) => theme.colors.grayscaleLight};
  text-align: center;
  padding: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`;

interface Props {
  permissions: Permission[];
  fallback?: ReactNode;
  forRoute?: boolean;
}

const HasPermission: FC<PropsWithChildren<Props>> = ({
  children,
  fallback,
  permissions,
  forRoute = false,
}) => {
  const hasPermission = useHasPermission(...permissions);

  if (hasPermission) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  if (forRoute) {
    return (
      <Wrap>
        <Text $type="heading1">Unauthorized</Text>
        <Text>You don't have permission to access this page</Text>
        <Button as={Link} to="/">
          Back to Homepage
        </Button>
      </Wrap>
    );
  }

  return null;
};

export default HasPermission;
